import React from 'react';
import styled from '@emotion/styled';

const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 16px;
`;

const Dot = styled.div<{ delay: string; opacity: number }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--color-text-primary);
  opacity: ${({ opacity }) => opacity};
  animation: pulse 1.5s infinite ease-in-out;
  animation-delay: ${({ delay }) => delay};

  @keyframes pulse {
    0%,
    100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.5);
    }
  }
`;

const Loader = () => {
  return (
    <LoaderWrapper>
      <Dot delay="0s" opacity={0.3} />
      <Dot delay="0.2s" opacity={0.6} />
      <Dot delay="0.4s" opacity={1} />
    </LoaderWrapper>
  );
};

export default Loader;
